import { Box, Flex } from 'components/ui';
import * as React from 'react';
import { ReactComponent as OwnerIcon } from 'img/owner.svg';
import { PrintsSupply } from '../Playlist';
import { useTheme } from 'styled-components';
import { DROP, PrintData } from '../common';
import { DROP_CONFIG } from '../Drops/dropConfig';

interface OwnershipDetailsProps {
  userOwnsOriginal: boolean;
  userOwnsPrints: boolean;
  print: PrintData;
  printsBalance: number;
  drop: DROP;
}

// const MobileView: React.FC<OwnershipDetailsProps> = ({
//   userOwnsOriginal,
//   userOwnsPrints,
//   print,
//   printsBalance,
//   drop,
// }) => {
//   const { colors } = useTheme();

//   return (
//     <Flex display={['flex', 'flex', 'none']} justifyBetween width={[null, null, '100%']}>
//       {(userOwnsPrints || userOwnsOriginal) && (
//         <Box mr="1">
//           <OwnerIcon fill={colors.highlight} />
//         </Box>
//       )}
//       {userOwnsOriginal && (
//         <Box mr="1">
//           <OriginalIcon />
//         </Box>
//       )}
//       <PrintsSupply supply={print.supply} ml={0} mr="3" balance={printsBalance} />
//     </Flex>
//   );
// };

const DesktopView: React.FC<OwnershipDetailsProps> = ({
  userOwnsOriginal,
  userOwnsPrints,
  print,
  printsBalance,
  drop,
}) => {
  const { colors } = useTheme();
  const userOwns = userOwnsOriginal || userOwnsPrints;

  return (
    <Box display={['block', 'block', 'block']} width={[null, null, '100%']}>
      <Flex>
        {(userOwnsPrints || userOwnsOriginal) && <OwnerIcon fill={colors.primary} />}
        {userOwns && (
          <Flex ml="2" color="primary">
            {userOwnsOriginal
              ? `You own the original ${userOwnsPrints ? `& ${printsBalance} Prints` : ''}`
              : `You own ${printsBalance} Print${printsBalance !== 1 ? 's' : ''}`}
          </Flex>
        )}
      </Flex>
      <Flex justifyBetween alignEnd width={[null, null, '100%']}>
        <Flex mt="2">
          <PrintsSupply supply={print.supply} mr="1" balance={printsBalance} hideBalance />
          <Box ml="2">[Max: {`${DROP_CONFIG[drop].maxSupply}`}]</Box>
        </Flex>
      </Flex>
    </Box>
  );
};

const OwnershipDetails: React.FC<OwnershipDetailsProps> = props => {
  return (
    <>
      {/* <MobileView {...props} /> */}
      <DesktopView {...props} />
    </>
  );
};

export default OwnershipDetails;
